<template>
  <!-- 1024*520 -->
  <div style="position: relative;">
    <div class="content-header">
      <div class="left">
        <span class="title">新增屏保方案</span>
      </div>
    </div>
    <div class="t-center">
      <Input v-model="data.name" style="width: 150px;margin: auto" placeholder="方案名称" />
    </div>
    <div style="margin-top:5px;">
      <div :class="{ upload: true, active: draging ? true : false }" ref="upload">
        <label class="ivu-btn ivu-btn-primary" for="uploads">点击或拖拽文件上传</label>
        <p class="text">图片推荐像素: 1024*520</p>
        <div class="file-list" v-if="files.length">
          <div class="item" v-for="(item, index) in files" :key="index">
            <div v-if="(item.blob || item.src) && item.name.indexOf('mp4') < 0" style="line-height: 0">
              <img :src="item.blob || imgSrc + item.src">
            </div>
            <div v-if="!item.blob && item.name.indexOf('mp4') >= 0" class="file">视频文件</div>
            <div class="name">{{ item.name }}</div>
            <div class="operate">
              <div style="width:24px">
                <Button @click="sortFiles(index, index - 1)" v-if="index !== 0" type="primary" size="small"
                  shape="circle" icon="md-arrow-dropleft"></Button>
              </div>
              <div style="width:24px">
                <Button @click="removeFiles(index)" type="error" size="small" shape="circle" icon="md-close"></Button>
              </div>
              <div style="width:24px">
                <Button @click="sortFiles(index, index + 1)" v-if="index !== files.length - 1" type="primary"
                  size="small" shape="circle" icon="md-arrow-dropright"></Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);" multiple="multiple"
        accept="image/png, image/jpeg, image/gif, image/jpg, audio/mp4, video/mp4" @change="chooseImage($event)">
      <div class="t-right" style="margin-top:5px">
        <Button type="primary" @click="upload" :loading="loading">保存</Button>
      </div>
    </div>
    <Spin fix v-if="loading">
      <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
      <div>加载中...</div>
    </Spin>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import OSS from 'ali-oss'
import config from '@/config'
export default {
  data () {
    return {
      data: {},
      draging: false,
      loading: false,
      // imgSrc: config.imgSrc,
      imgSrc: '',
      files: []
    }
  },
  mounted () {
    if (this.$route.params.id != '0') {
      this.getData()
    }
    this.bindRef()
    console.log(process.env.NODE_ENV)
  },
  methods: {
    getData () {
      this.GetScreenSaverInfo({ id: this.$route.params.id }).then(res => {
        this.data = res
        if (res.names) {
          res.names.split(',').map((name, index) => {
            let src = res.src.split(',')
            this.files.push({
              name: name,
              src: src[index]
            })
            console.log('测试', src[index])
          })
        }
      })
    },
    removeFiles (index) {
      this.files.splice(index, 1)
    },
    sendSock (data) {
      this.socketSend({ action: 10005, value: { machine_ad_id: data.id } })
    },
    saveScreenSaver () {
      let data = {
        id: this.data.id,
        name: this.data.name,
        names: [],
        src: []
      }

      this.files.map(item => {
        data.names.push(item.name)
        data.src.push(item.src)
      })
      console.log(this.data, data)
      data.names = data.names.join(',')
      data.src = data.src.join(',')
      this.SaveScreenSaver(data).then(res => {
        if (res) {
          this.loading = false
          this.$Message.success('操作成功')
          this.sendSock(data)
          this.$router.back()
        }
      })
    },
    // 保存
    upload () {
      let formData = new FormData()
      if (this.data.name) {
        if (this.files.length > 0) {
          if (this.files[0].type == 'video/mp4') {
            if (this.files.length > 5) {
              this.$Message.error('最多支持5个视频文件!')
              return
            }
          } else {
            if (this.files.length > 20) {
              this.$Message.error('最多支持20个图片文件!')
              return
            }
          }
          this.loading = true
          this.saveScreenSaver()
        } else {
          this.$Message.error('请上传文件')
        }
      } else {
        this.$Message.error('未填写方案名称')
      }
    },
    // 数组位移排序
    sortFiles (from, to) {
      let temp = JSON.parse(JSON.stringify(this.files))
      temp[to] = this.files[from]
      temp[from] = this.files[to]
      this.files = temp
    },
    // 点击按钮选择预览图片
    chooseImage (e) {
      let index
      for (var i = 0; i < e.target.files.length; i++) {
        let file = e.target.files[i]
        console.log('文件大小:' + file.size)
        if (file.type === 'video/mp4') { // 视频
          if (file.size > 50 * 1048576) { // 如果大于50MB就提示
            this.$Message.error('文件：' + file.name + ' 不能超过100MB!')
            continue
          }
          if (index > 5) {
            this.$Message.error('最多支持5个视频文件!')
            return
          }
          index++
        } else { // 图片
          if (file.size / 1024 > 500) { // 如果大于500KB就提示
            this.$Message.error('文件：' + file.name + ' 不能超过500kb!')
            continue
          }
          if (index > 20) {
            this.$Message.error('最多支持20个图片文件!')
            return
          }
          index++
        }
        this.UploadFile(file)
      }
    },
    UploadFile (file) {
      this.loading = true
      const OssClient = new OSS({
        region: config.oss.region,
        endpoint: config.oss.region,
        accessKeyId: config.oss.accessKeyId,
        accessKeySecret: config.oss.secretAccessKey,
        bucket: config.oss.bucket
      })
      OssClient.put('screen/' + file.name, file)
        .then(res => {
          this.loading = false
          // if (!this.formData.name) this.formData.name = file.name;
          this.formatFiles(file, res.url)
          // this.upload.uploadStatus = false;
          // this.$Message.success("上传成功");
        })
        .catch(err => {
          console.log(err)
          this.$Message.success('error')
        })
    },
    // 格式化文件
    formatFiles (file, url) {
      if (file.type === 'video/mp4') {
        this.files.push({
          file: file,
          src: url,
          blob: '',
          name: file.name,
          size: file.size
        })
      } else {
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = res => {
          this.files.push({
            file: file,
            src: url,
            blob: res.target.result,
            name: file.name,
            size: file.size
          })
        }
      }
    },
    bindRef () {
      // 绑定上传图片拖拽文件时间
      this.$refs.upload.addEventListener(
        'dragover',
        e => {
          e.preventDefault()
          if (!this.draging) {
            this.draging = true
          }
        },
        false
      )
      this.$refs.upload.addEventListener(
        'dragleave',
        e => {
          e.preventDefault()
          if (this.draging) {
            this.draging = false
          }
        },
        false
      )
      // 拖拽结束时触发
      this.$refs.upload.addEventListener(
        'drop',
        e => {
          e.preventDefault()
          this.draging = false
          let files = e.dataTransfer.files
          for (var i = 0; i < files.length; i++) {
            this.formatFiles(files[i])
          }
        },
        false
      )
    },
    ...mapActions([
      'ScreenSaverUpload',
      'SaveScreenSaver',
      'GetScreenSaverInfo',
      'socketSend'
    ])
  }
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
